import { create } from 'zustand';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCustomMediaQuery } from 'academy-common-lib/utils/Styling';
import { useShort } from '../shortContent/shortContentQueries';
import { ALLOWED_OTG_IDS } from '../../constants/SoftwareDiscoveryConstants';
export const useRequestLearnWhileDoing = create(set => ({
  isLearnWhileDoingScreenEnabled: false,
  isLearnWhileDoingEnabled: false,
  playHsVideo: false,
  isVideoPlayed: false,
  isVideoFinished: false,
  handlePlayHsVideo: () => set(() => ({
    playHsVideo: true
  })),
  handleDisableLearnWhileDoingScreen: () => set(() => ({
    isLearnWhileDoingScreenEnabled: false
  })),
  handleEnableLearnWhileDoingScreen: () => set(() => ({
    isLearnWhileDoingScreenEnabled: true
  })),
  handleDisableLearnWhileDoing: () => set(() => ({
    isLearnWhileDoingEnabled: false
  })),
  handleEnableLearnWhileDoing: () => set(() => ({
    isLearnWhileDoingEnabled: true
  })),
  handleVideoPlayed: flag => set(() => ({
    isVideoPlayed: flag
  })),
  handleVideoFinished: flag => set(() => ({
    isVideoFinished: flag
  }))
}));
export const useLearnByDoing = () => {
  const {
    isLearnWhileDoingScreenEnabled,
    playHsVideo,
    handleEnableLearnWhileDoingScreen,
    handleDisableLearnWhileDoingScreen
  } = useRequestLearnWhileDoing();
  const {
    shortId
  } = useParams();
  const {
    short
  } = useShort(Number(shortId), !shortId);
  const learnByDoingEnabled = short && 'learnByDoingEnabled' in short && short.learnByDoingEnabled || ALLOWED_OTG_IDS.includes(Number(shortId));
  const isScreenSizeAccepted = useCustomMediaQuery('(max-width: 1024px)');
  useEffect(() => {
    if (!isScreenSizeAccepted && learnByDoingEnabled) {
      handleEnableLearnWhileDoingScreen();
    } else {
      handleDisableLearnWhileDoingScreen();
    }
  }, [handleDisableLearnWhileDoingScreen, handleEnableLearnWhileDoingScreen, isScreenSizeAccepted, learnByDoingEnabled]);
  const updatedVideoProps = {
    autoPlay: playHsVideo
  };
  return {
    shouldRenderLearnByDoingScreen: isLearnWhileDoingScreenEnabled && learnByDoingEnabled,
    updatedVideoProps
  };
};